module.exports = __webpack_public_path__ + "static/media/hs-stories.5f88ac93.jpg";